import React from "react";

const Socials = () => {
    return (
<>
<div class="socials">
<h1 >Socials coming soon..</h1>
</div>
</>
    );
};

export default Socials;
